import Images from "../constant/Images";

export const  RoleList = [
    {
        label : "Super Admin",
        value : "SUPER_ADMIN",
        icon : Images.AdminIcon,
    },
    {
        label : 'Admin',
        value : 'ADMIN',
        icon : Images?.AdminIcon
    },{
        label : 'Personal Assistant',
        value : 'PERSONAL_ASSISTANT',
        icon : Images?.AssistanceIcon
    },

]